import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";

import { getBadges, getBadgeDetails, resetField } from "../../store/actions";
import BadgeCard from "./badgeCard";
import BadgeDetails from "./badgeDetails";

const BadgeListing = ({ getBadges, getBadgeDetails, badgeList, memberBadges }) => {
    useEffect(() => {
        getBadges();
    }, [getBadges]);

    const [badges, setBadges] = useState([]);
    const [activBadge, setActivBadge] = useState();
    const [showPanel, setShowPanel] = useState(true);

    const openPanel = (badge) => {
        setActivBadge(badge);
        setShowPanel(true);
    }

    useEffect(() => {
        activBadge && getBadgeDetails(activBadge.id);
    }, [activBadge, getBadgeDetails]);

    useEffect(() => {
        badgeList && badgeList.length && setBadges(badgeList);
    }, [badgeList]);

    return <section className="page page-badge-list">
        <div className="container">
            <h3>My Badges</h3>
            <div className="card-wrap">
                {badges.map(badge => <BadgeCard key={badge.id} cardDetails={badge} onClick={openPanel} />)}
            </div>
        </div>
        {activBadge && memberBadges ? <BadgeDetails show={showPanel} toggle={setShowPanel} badgeDetails={activBadge} memberBadges={memberBadges} /> : null}
    </section>
}

const mapStateToProps = (state) => {
    const { Badges } = state;
    return {
        badgeList: get(Badges, "badgesResult.results", null),
        memberBadges: get(Badges, "badgeDetails", null)
    };
};

const mapDispatchToProps = {
    getBadges,
    getBadgeDetails,
    resetField
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BadgeListing);
